/**
 * BACnet object types as the gateway expects them in a point's or an alarm's `config`. The OpenAPI spec types
 * `config` as an opaque record (the gateway validates it), so the set is declared here.
 */
enum BacnetObjectType {
  analogInput = "analogInput",
  analogOutput = "analogOutput",
  analogValue = "analogValue",
  binaryInput = "binaryInput",
  binaryOutput = "binaryOutput",
  binaryValue = "binaryValue",
  multiStateInput = "multiStateInput",
  multiStateOutput = "multiStateOutput",
  multiStateValue = "multiStateValue",
}

export { BacnetObjectType };
